import type { Component, Entity2D } from '../../../odie';
import { CountBlockOptionDef } from '../../defs/block';
import { BigEggBlockProps } from './BigEggBlock';
import { BigEggBlockView } from './BigEggBlockView';

export type BigEggBlockComponentOptions = {
  props: BigEggBlockProps;
  option?: number;
};

export class BigEggBlockComponent implements Component {
  public static readonly NAME = 'blockBigEgg';
  public entity!: Entity2D;
  public view!: BigEggBlockView;
  private props!: BigEggBlockProps;

  public init(options: BigEggBlockComponentOptions): void {
    const optionDef = options.props.options?.[
      options.option || 0
    ] as CountBlockOptionDef;

    this.props = options.props;
    this.view = new BigEggBlockView(options.props);
    this.count = optionDef.count;

    // Set the getGameplayState retrieval function
    this.entity.c.block.getGameplayState = () => this.getGameplayState();
  }

  public get count(): number {
    return this.view.count;
  }

  public set count(value: number) {
    this.view.count = value;
  }

  public getGameplayState(): number {
    const options = this.props.options as CountBlockOptionDef[];
    return options.findIndex((opt) => {
      return opt.count === this.view.count;
    });
  }
}
